// src/components/TaskInput.js

import React, { useState, useEffect } from 'react';

function TaskInput({ newTask, setNewTask, estimatedPomodoros, setEstimatedPomodoros, addTask }) {
  const [localSessions, setLocalSessions] = useState(
    estimatedPomodoros === 1 || estimatedPomodoros === "1" ? "" : estimatedPomodoros
  );

  useEffect(() => {
    setLocalSessions(estimatedPomodoros === 1 ? "" : estimatedPomodoros);
  }, [estimatedPomodoros]);

  const handleSessionsChange = (e) => {
    const value = Number(e.target.value);
    setLocalSessions(value);
    setEstimatedPomodoros(value);
  };

  const handleAdd = () => {
    if (newTask.trim()) {
      const sessions = localSessions === "" ? 1 : Number(localSessions);
      setEstimatedPomodoros(sessions); // sync before submit
      addTask();
    }
  };

  return (
    <div className="task-input">
      <div className="form-row">
        <input
          type="text"
          value={newTask}
          onChange={(e) => setNewTask(e.target.value)}
          placeholder="Name:"
        />
      </div>
      <div className="form-row">
        <input
          type="number"
          min="1"
          max="20"
          value={localSessions}
          onChange={handleSessionsChange}
          placeholder="Sessions:  4 (1 full Pomodoro)"
          onFocus={(e) => e.target.select()}
        />
      </div>
      <button className="add-task-button" onClick={handleAdd}>
        Add Task
      </button>
    </div>
  );
}

export default TaskInput;
